var map = {
	"./avatar.jpg": "915e",
	"./dino.jpg": "9b0e",
	"./elvis.jpeg": "a918",
	"./home1.jpg": "bcf5",
	"./home2.jpg": "3fe9",
	"./home3.jpg": "3d0b",
	"./ian.jpg": "4621",
	"./jorge.jpg": "215e",
	"./keith.jpg": "1099",
	"./logo-coreinsi.png": "32f8",
	"./logo-unsch.png": "dce8",
	"./logo.png": "cf05",
	"./michael.jpg": "6f60",
	"./speakers-background.gif": "9e8f",
	"./up-arrow.png": "2043"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";